module.exports = __webpack_public_path__ + "odinstatic/v5.0.2/media/cms-panel.35180de3.svg";